import { SET_RTCO_P13N_DATA } from 'constants/actionTypes/personalization';
import getP13nRtcoData from 'services/api/p13n/getP13nRtcoData';
import { coreUserDataSelector } from 'viewModel/selectors/user/coreUserDataSelector';

const setRtcoP13nData = payload => {
    return {
        type: SET_RTCO_P13N_DATA,
        payload
    };
};

const fetchRtcoP13nData = ({ contextId }) => {
    return async (dispatch, getState) => {
        // Mark in-flight before validation so consumers never confuse initial `null` with a started fetch.
        dispatch(setRtcoP13nData(undefined));

        const state = getState();
        const user = coreUserDataSelector(state);
        const { userId: atgId } = user;

        if (!atgId || !contextId) {
            dispatch(setRtcoP13nData(null));

            return;
        }

        try {
            const { country, channel, language } = Sephora.renderQueryParams;
            const rtcoData = await getP13nRtcoData({
                channel,
                country,
                language,
                atgId,
                contextId
            });

            // Always resolve to either an object (promo) or null (no promo) so
            // consumers can flip loading states reliably.
            dispatch(setRtcoP13nData(rtcoData ?? null));
        } catch (error) {
            Sephora.logger.error('Error getting RTCO P13N data:', error);
            // Stop loading on errors.
            dispatch(setRtcoP13nData(null));
        }
    };
};

export {
    fetchRtcoP13nData, setRtcoP13nData
};
